import React from 'react'
import '../styles/chart.css'
import Chart from 'react-apexcharts';

class PieChart extends React.Component {
  constructor(props) {
    super(props);
    const { tableRowsData } = props;
    let series = [];
    let labels = [];
    if (tableRowsData && tableRowsData.players) {
      series = tableRowsData.players.map(player => player.buyinAmount);
      labels = tableRowsData.players.map(player => `${player.playerName} - ${player.buyinAmount}`);
    }

    this.state = {
      options: {
        chart: {
          type: 'pie',
        },
        labels: series,
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5', '#546E7A', '#D4526E', '#8D5B4C', '#F86624'],
        legend: {
          fontSize: '20px'
        },

      },
      series: labels,
    };
  }
  // Update chart data when props change
  componentDidUpdate(prevProps) {
    if (prevProps.tableRowsData !== this.props.tableRowsData) {
      const { tableRowsData } = this.props;
      let series = [];
      let labels = [];
      if (tableRowsData && tableRowsData.players) {
        series = tableRowsData.players.map(player => player.buyinAmount);
        labels = tableRowsData.players.map(player => `${player.playerName}: ${player.buyinAmount}`);
      }

      this.setState({
        options: {
          ...this.state.options,
          labels: labels,
        },
        series: series,
      });
    }
  }

  render() {
    return (
      <div className='chartContainer'>
        <h2 className='title'>התפלגות סך כל הפריטה</h2>
        <div className='chart'>
          <Chart options={this.state.options} series={this.state.series} type="pie" height="300px" />
        </div>
      </div>
    );
  }
}

export default PieChart;
